import { useState } from 'react';
import toast from 'react-hot-toast';
import useAppStore from '../store/app.store';
import api from '../services/api';

const SENHA_PROVISORIA = '123mudar';

const inputStyle = {
  width: '100%', padding: '13px 16px', boxSizing: 'border-box',
  borderRadius: 12, border: '1.5px solid #1e293b',
  fontSize: 14, color: '#f1f5f9', outline: 'none', background: '#0f172a',
};
const labelStyle = {
  display: 'block', fontSize: 11, fontWeight: 700, color: '#475569',
  marginBottom: 7, letterSpacing: '0.1em', textTransform: 'uppercase',
};

export default function TrocarSenhaObrigatoria() {
  const usuario = useAppStore((s) => s.usuario);
  const setUsuarioLogado = useAppStore((s) => s.setUsuarioLogado);
  const logout = useAppStore((s) => s.logout);
  const [form, setForm] = useState({ atual: '', nova: '', confirmar: '' });
  const [salvando, setSalvando] = useState(false);

  const salvar = async (e) => {
    e.preventDefault();
    if (form.nova.length < 6) return toast.error('A nova senha precisa ter pelo menos 6 caracteres.');
    if (form.nova === SENHA_PROVISORIA) return toast.error('Escolha uma senha diferente da provisória.');
    if (form.nova !== form.confirmar) return toast.error('As senhas não coincidem.');
    setSalvando(true);
    try {
      await api.post('/auth/trocar-senha', { senha_atual: form.atual, nova_senha: form.nova });
      toast.success('Senha criada. Bem-vindo ao Legacy Hub!');
      setUsuarioLogado({ ...usuario, deve_trocar_senha: false });
    } catch (err) {
      toast.error(err.response?.data?.error || 'Não foi possível trocar a senha.');
      setSalvando(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: '#080c18', fontFamily: "'Inter', sans-serif", padding: '24px 16px',
    }}>
      <div style={{ width: '100%', maxWidth: 420, padding: '0 24px' }}>
        <h1 style={{ color: '#fff', fontSize: 24, fontWeight: 800, marginBottom: 8, textAlign: 'center' }}>
          Crie sua senha
        </h1>
        <p style={{ color: '#64748B', fontSize: 13, textAlign: 'center', marginBottom: 32, lineHeight: 1.6 }}>
          Olá, {usuario?.nome?.split(' ')[0]}! Você entrou com a senha provisória.
          Para continuar, defina uma senha pessoal.
          {usuario?.username && <><br />Seu usuário de acesso é <strong style={{ color: '#A5B4FC' }}>{usuario.username}</strong>.</>}
        </p>

        <form onSubmit={salvar} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div>
            <label style={labelStyle}>Senha provisória</label>
            <input type="password" style={inputStyle} value={form.atual} required autoComplete="current-password"
              onChange={(e) => setForm((p) => ({ ...p, atual: e.target.value }))} />
          </div>
          <div>
            <label style={labelStyle}>Nova senha</label>
            <input type="password" style={inputStyle} value={form.nova} required autoComplete="new-password"
              onChange={(e) => setForm((p) => ({ ...p, nova: e.target.value }))} />
          </div>
          <div>
            <label style={labelStyle}>Confirmar nova senha</label>
            <input type="password" style={inputStyle} value={form.confirmar} required autoComplete="new-password"
              onChange={(e) => setForm((p) => ({ ...p, confirmar: e.target.value }))} />
          </div>
          <p style={{ fontSize: 12, color: '#475569' }}>Mínimo de 6 caracteres.</p>
          <button type="submit" disabled={salvando} style={{
            padding: '14px', borderRadius: 12, border: 'none', marginTop: 4,
            fontSize: 14, fontWeight: 700, color: '#fff', cursor: salvando ? 'not-allowed' : 'pointer',
            background: salvando ? '#2d2f6e' : 'linear-gradient(135deg, #3B3BAF 0%, #5B5BD6 100%)',
          }}>
            {salvando ? 'Salvando...' : 'Salvar e entrar'}
          </button>
          <button type="button" onClick={logout}
            style={{ background: 'none', border: 'none', color: '#64748B', fontSize: 12, cursor: 'pointer', marginTop: 4 }}>
            Sair
          </button>
        </form>
      </div>
    </div>
  );
}
